import { render, staticRenderFns } from "./CourseTakeNavbar.vue?vue&type=template&id=2a5a8c30&"
import script from "./CourseTakeNavbar.vue?vue&type=script&setup=true&lang=ts&"
export * from "./CourseTakeNavbar.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports